"use client"

import React, { useState } from 'react'
import AnimatedCounter from './AnimatedCounter';
const HighlightsAndStats = ({ data }) => {

    return (
        <div className='w-full mt-5 sm:mt-8 md:mt-10 lg:mt-20'>
            <div className="text-center ">
                <div
                    className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 md:mb-16"
                >
                    {data.announcements.map((announcement, index) => (
                        <div
                            key={index}
                            className="w-full group px-6 md:px-6 lg:px-8 py-5 shadow-xl hover:shadow-2xl hover:-translate-y-2 
                            transition-all duration-500 bg-black/40"
                            style={{
                                backgroundImage: "url('/stats-bg.webp')",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        >
                            <p className="text-2xl font-bold mb-4 group-hover:scale-110 transition-transform duration-300 text-start text-white">
                                1st in India
                            </p>

                            <p className="text-lg leading-normal text-start transition-colors duration-300 text-white">
                                {announcement}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="flex items-center justify-center">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-6 ">
                        {data.stats.map((stat, index) => (
                            <div
                                key={index}
                                className="group border-2 border-[#e5e5e5] text-black rounded-lg px-5 py-6
                        hover:shadow-3xl hover:scale-105 transition-all duration-500 text-center
                        flex flex-col items-center justify-center"
                            >
                                <div className="text-3xl md:text-4xl font-bold mb-1 md:mb-2">
                                    <AnimatedCounter value={stat.value} />
                                </div>
                                <div className="text-[clamp(10px,1.2vw,16px)] opacity-90">
                                    {stat.label}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


            </div>
        </div>
    )
}

export default HighlightsAndStats